export const REALTIME_SCOPES = {
	CONVERSATION: "conversation",
	INBOX: "inbox",
	PHOTO_ROULETTE: "photo_roulette",
	VOICE_GUESSER: "voice_guesser",
	WALKIE_TALKIE: "walkie_talkie",
} as const;

export type RealtimeScope = (typeof REALTIME_SCOPES)[keyof typeof REALTIME_SCOPES];
